export default {
  AUTO: 'Lending-AUTO',
  AUTO_PREAPPROVAL: 'Lending-AUTO-Preapproval',
  BANKING_ONLY: 'Lending-BankingOnly',
  PAYDAY: 'Lending-Payday',
  SHORTTERM: 'Lending-ShortTerm',
  TITLE: 'Lending-Title',
  INSTALLMENT: 'Lending-Installment',
};
